import Settings from "../settings";

export class Abstracts {
    public static BaseUrl = "/abstracts";
    public static Compose = Abstracts.BaseUrl + "/compose";
    public static Confirmation = Abstracts.BaseUrl + "/confirmation";
}

export class Admin {
    public static Landing = "/admin";
}

export class AdminAbstracts {
    public static BasePath = "/admin/abstracts";
}

export class AdminEmailTemplate {
    public static List = "/admin/email-templates";
    public static Edit = "/admin/email-templates/edit";
}

export class AdminEvent {
    public static List = "/admin/events";
    public static Edit = "/admin/event/edit";
}

export class AdminNav {
    public static List = "/admin/nav";
    public static SortItems = "/admin/nav/sort";
}

export class AdminPage {
    public static List = "/admin/pages";
    public static Edit = "/admin/page/edit";
}

export class AdminTag {
    public static List = "/admin/tags";
}

export class Account {
    public static CreateAccount = "/create-account";
    public static Login = "/login";
    public static Logout = "/logout";
    public static ResetPassword = "/reset-password";
}

export class CareerCenter {
    public static AdviceResources = "/career-center/resources";
    public static Landing = "/career-center";
    public static JobDirectory = "/career-center/jobs";
    public static ResumeDirectory = "/career-center/resumes";

    public static Job = {
        Details: "/career-center/job-",
        Post: "/career-center/job/post",
        Review: "/career-center/job/review",
        Confirmation: "/career-center/job/confirmation",
    };

    public static Resume = {
        Details: "/career-center/resume-",
        Post: "/career-center/resume/post",
        Review: "/career-center/resume/review",
        Confirmation: "/career-center/resume/confirmation",
    };
}

export class Page {
    public static TermsOfUse = "/terms-of-use";
    public static PrivacyPolicy = "/privacy-statement";
}

export class User {
    public static RoutePrefix = "/user";

    public static Account = User.RoutePrefix + "/account";
    public static FinancialDisclosureUpdate = User.RoutePrefix + "/financial-disclosure";

    public static Abstracts = {
        UserAbstracts: User.RoutePrefix + "/abstracts",
        AbstractDetails: User.RoutePrefix + "/abstract",
    };

    public static AbstractGrading = {
        Abstracts: User.RoutePrefix + "/grade-abstracts",
    };

    public static CareerCenter = {
        EditJob: User.RoutePrefix + "/career-center/my-jobs/edit",
        EditResume: User.RoutePrefix + "/career-center/my-resumes/edit",
        Jobs: User.RoutePrefix + "/career-center/my-jobs",
        Resumes: User.RoutePrefix + "/career-center/my-resumes",
    };
}

export class Helper {
    public static Login(returnUrl?: string) {
        return Account.Login + (returnUrl ? `?returnUrl=${encodeURIComponent(returnUrl)}` : "");
    }
}

export const AccessDenied = "/access-denied";
export const Home = "/";

// Admin Abstracts //
export const AdminAbstractAddNew = (eventId: number) => {
    return `${AdminAbstracts.BasePath}/${eventId}/edit/new`;
};

export const AdminAbstractDetails = (eventId: number, a: string | { guid: string }) => {
    const guid = typeof a === "string" ? a : a.guid;
    return `${AdminAbstracts.BasePath}/${eventId}/details/${guid}`;
};

export const AdminAbstractEdit = (eventId: number, a: string | { guid: string }) => {
    const guid = typeof a === "string" ? a : a.guid;
    return `${AdminAbstracts.BasePath}/${eventId}/edit/${guid}`;
};

export const AdminAbstractEditDetails = (eventId: number, a: string | { guid: string }) => {
    const guid = typeof a === "string" ? a : a.guid;
    return `${AdminAbstracts.BasePath}/${eventId}/edit/${guid}/details`;
};

export const AdminAbstractEditUploads = (eventId: number, a: string | { guid: string }) => {
    const guid = typeof a === "string" ? a : a.guid;
    return `${AdminAbstracts.BasePath}/${eventId}/edit/${guid}/uploads`;
};

export const AdminAbstractEditPermissions = (eventId: number, a: string | { guid: string }) => {
    const guid = typeof a === "string" ? a : a.guid;
    return `${AdminAbstracts.BasePath}/${eventId}/edit/${guid}/permissions`;
};

export const AdminAbstractEditSettings = (eventId: number, a: string | { guid: string }) => {
    const guid = typeof a === "string" ? a : a.guid;
    return `${AdminAbstracts.BasePath}/${eventId}/edit/${guid}/settings`;
};

export const AdminAbstractDisclosures = (eventId: number) => {
    return `${AdminAbstracts.BasePath}/${eventId}/disclosures`;
};

export const AdminAbstractInvitationEmails = (eventId: number) => {
    return `${AdminAbstracts.BasePath}/${eventId}/acceptance-emails`;
};

export const AdminAbstractList = (eventId: number) => {
    return `${AdminAbstracts.BasePath}/${eventId}`;
};

export const AdminAbstractListGroupEdit = (eventId: number, groupId: number) => {
    return `${AdminAbstracts.BasePath}/${eventId}/group/${groupId}`;
};

export const AdminAbstractListGroups = (eventId: number) => {
    return `${AdminAbstracts.BasePath}/${eventId}/groups`;
};

export const AdminAbstractTypeEdit = (eventId: number, abstractTypeId: number) => {
    return `${AdminAbstracts.BasePath}/${eventId}/type/${abstractTypeId}`;
};

// Admin Email templates //
export const AdminEmailTemplateEdit = (id: number) => {
    return `${AdminEmailTemplate.Edit}/${id}`;
};

// Admin Events //
export const AdminEventEdit = (eventId: number) => {
    return `${AdminEvent.Edit}/${eventId}`;
};

export const AdminEventCalendarEdit = (eventId: number) => {
    return `${AdminEvent.Edit}/${eventId}/calendar`;
};

export const AdminEventCalendarSubEventEdit = (mainEventId: number, parentId: number, subEventId: number) => {
    return AdminEventCalendarEdit(mainEventId) + `?edit=${parentId},${subEventId}`;
};

// Abstracts //
export const AbstractsCompose = (eventId: number, step: string, guid: string) => {
    return `${Abstracts.Compose}/${eventId}${guid ? ("/" + guid) : ""}${step ? ("/" + step) : ""}`;
};

export const AbstractsComposeNew = (eventId: number) => {
    return `${Abstracts.Compose}/${eventId}/new/authorship`;
};

export const AbstractsConfirmation = (guid: string) => {
    return `${Abstracts.Confirmation}/${guid}`;
};

// User abstracts //
export const UserAbstractDetails = (guid: string) => {
    return `${User.Abstracts.AbstractDetails}/${guid}`;
};

// User abstracts grading //
export const UserAbstractGradingDetails = (guid: string) => {
    return `${User.AbstractGrading.Abstracts}/${guid}`;
};

// Legacy //
export class Legacy {
    public static AbstractsArchive = Settings.AsrsLegacyUrl + "/members/abstracts-archive";
    public static MakePayment = Settings.AsrsLegacyUrl + "/members/payment";
    public static SpeakerGuidelines = "https://www.asrs.org/content/documents/asrs-speaker-guidelines-and-attestation.pdf";

    public static AdminMemberProfile = (legacyMemberId: number | null) => {
        return `${Settings.AsrsLegacyUrl}/extranet/Membership/Profile/${legacyMemberId || 0}`;
    }

    public static GetUrl(path: string) {
        return Settings.AsrsLegacyUrl + path;
    }
}



// WEBPACK FOOTER //
// ./src/constants/paths.ts